/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';

import NewsletterModel, { ChannelType } from 'cio/models/newsletter';

interface CioNewslettersListArgs {
  newsletters: NewsletterModel[];
  channel: ChannelType;
  afterDeleteNewsletterAction: () => unknown;
  afterCopyNewsletterAction?: () => unknown;
  onTagClicked: () => unknown;
}

export default class CioNewslettersList extends Component<CioNewslettersListArgs> {
  headers = [
    {
      label: 'Channel',
      class: 'w-icon',
    },
    {
      label: 'Name',
      class: 'lg:pr-6',
    },
    {
      label: 'State',
      class: 'w-1/12',
    },
    {
      label: 'Metrics',
      class: 'w-[500px]',
    },
    {
      label: 'Actions',
      class: 'w-[80px]',
    },
  ];

  queueTask = task(
    {
      maxConcurrency: 4,
      enqueue: true,
    },
    async (queuedTask: any) => {
      await queuedTask.perform();
    },
  );
}
